import React from "react";
import { Container } from "react-bootstrap";
import { useLocation, NavLink } from "react-router-dom";
import rightArrow from "../../assets/images/icons/rightArrow.png";

const ChuppaPagesComponet = () => {
  const location = useLocation();
  const path = location.pathname.substring(1).toUpperCase();

  return (
    <section>
      <Container>
        <nav className="my-5 font-poppins route-navigation">
          <ul className="d-flex gap-4 text-light-gray fs-20 fw-bold ">
            <NavLink to={"/"}>
              {" "}
              <li className="list-unstyled">HOME</li>
            </NavLink>
            <li className="list-unstyled">
              <img loading="lazy"  src={rightArrow} alt="" />
            </li>
            <li className="list-unstyled text-dark">{path}</li>
          </ul>
        </nav>
      </Container>
    </section>
  );
};

export default ChuppaPagesComponet;
